<template>
  <div class="contents_wrapper">
    <div class='contents'>
      <h2 class="large_label">案件情報変更依頼</h2>

      <WorkDataTable :work="tempWork"/>

      <button
        v-if="isOperator"
        @click="acceptChange()"
        class="yellow-ellipse_button">
        変更を承諾する
      </button>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";
  import collection from "@/assets/js/functions/firebase/firestore/collection";
  import sub_collection from "@/assets/js/functions/firebase/firestore/sub_collection";
  import caller from "@/assets/js/functions/firebase/cloud_functions/caller";

  import WorkDataTable from "@/components/objects/table/WorkDataTable";
  import COLLECTION_NAMES from "@/assets/js/constants/collection_names";
  export default {
    name: "TempWorkDetail",

    components: {WorkDataTable},

    mixins: [collection, sub_collection, caller],

    data() {
      return {
        work: {},
        tempWork: {},
        matching: {},
      }
    },


    computed: {
      ...mapGetters({uid: 'auth/uid'}),

      isOperator() {
        return this.matching.operator && (this.uid === this.matching.operator.id)
      }
    },

    beforeCreate() {
      Object.assign(this, {COLLECTION_NAMES});
    },

    async created() {
      this.matchingId = location.pathname.replace(/^\/matching\/meeting\/temp_work\//, '');
      this.matchingId = this.matchingId.replace(/\/*$/, '');

      await this.getDoc(
        COLLECTION_NAMES.MATCHINGS,
        this.matchingId,
        {}).then(async matching => {
        this.matching = matching;
        this.setTalker(matching);
      }).catch(() => {
        // Vueでは例外に何もしない（thenの処理を発生させたくないので、例外は投げるが関数側で処理済み）
      });

      const query = this.subCollectionDocRef(
        COLLECTION_NAMES.WORKS,
        this.matching.work.id,
        COLLECTION_NAMES.TEMPS,
      ).orderBy('createdAt', "desc");
      await this.retrieveSubCollectionDocs(query).then(docs => {
        this.tempWork = docs[0];
      });
    },

    methods: {
      async acceptChange() {
        const params = {matchingId: this.matchingId, workId: this.matching.work.id};

        await this.callFunction(
          'transcribeWorkFromTemp',
          params
        ).then(() => {
          this.showSuccessMessage('更新依頼を受諾しました。')
          this.$router.push({name: 'Meeting', params: {matchingId: this.matchingId}});
        }).catch(() => {
          // Vueでは例外に何もしない（thenの処理を発生させたくないので、例外は投げるが関数側で処理済み）
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
  .contents_wrapper {
    background: linear-gradient(45deg, $client_third, $client_third, $operator_secondary, $operator_secondary);

    > .contents {
      @include index-contents;

      > .user-data_block {
        margin-top: 4rem;
      }

      > .user-data_block, > .operator-data_block {
        width: 100%;
      }
    }
  }
</style>